export default __webpack_public_path__ + "static/media/user-ben.3655b0b4.png";